export default "__VITE_ASSET__BWli0$AC__"